import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { ConfirmationService, Message, SelectItem } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { Operacao } from 'src/app/admihair/api/dto/operacao';
import { OperacaoFinanceiraService } from 'src/app/admihair/service/operacao-financeira.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';

@Component({
  selector: 'app-operacao-financeira-listar',
  templateUrl: './operacao-financeira-listar.component.html',
  styleUrls: ['./operacao-financeira-listar.component.scss']
})
export class OperacaoFinanceiraListarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  situacoesStatus: SelectItem[] = [
    { label: 'ATIVOS', value: true },
    { label: 'INATIVOS', value: false }
  ];
  situacaoSelecionada: boolean = true;
  empresaSelecionada?: Empresa;
  operacoes: Operacao[] = [];
  loading: boolean = false;
  loadingOperacoes: boolean = false;

  constructor(
    private operacaoFinanceirasService: OperacaoFinanceiraService,
    private confirmationService: ConfirmationService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    erroService: ErroService,
    utilStorageService: UtilStorageService) {
    super(erroService, utilStorageService)
  }

  ngOnInit(): void {
    this.loadingOperacoes = true;
    this.verificarPermissoes();
    this.empresaSelecionada = this.getEmpresa();
    if (this.permissaoListar) {
      this.listarOperacoes();
    }
  }

  listarOperacoes() {
    this.operacaoFinanceirasService.listarPorEmpresaESituacao(this.empresaSelecionada?.id, this.situacaoSelecionada).subscribe({
      next: (data: Operacao[]) => {
        this.loadingOperacoes = false;
        this.operacoes = data;
      },
      error: (err: any) => {
        this.loadingOperacoes = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  excluirOperacao(id: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.operacaoFinanceirasService.excluir(id).subscribe({
          next: () => {
            this.exibirMensagemSucesso();
            this.listarOperacoes();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        });
      }
    });
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  editarOperacao(id: number) {
    this._router.navigate(["/apps/operacao-financeira/editar/" + id], { relativeTo: this._activatedRoute })
  }

  detalharOperacao(id: number) {
    this._router.navigate(["/apps/operacao-financeira/detalhar/" + id], { relativeTo: this._activatedRoute })
  }

  verificarPermissoes() {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_OPERACAO_FINANCEIRA');
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_OPERACAO_FINANCEIRA');
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_OPERACAO_FINANCEIRA');
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_OPERACAO_FINANCEIRA');
    this.permissaoExcluir = this.verificarPermissao('PERM_EXCLUIR_OPERACAO_FINANCEIRA');
  }
}
